<template>
  <div id="dailyWeather" class="container">
    <div class="row">
      <div class="col-12">{{ place }} -- {{ today }}</div>
    </div>
    <div class="row">
      <div class="col-6">Temperature: {{ currentTemp }}</div>
      <div class="col-6">Feels like: {{ feelsLike }}</div>
    </div>
    <div class="row">
      <div class="col-12">
        <p>Current: {{ description }}</p>
        <p>
          <img
            class="currentIcon"
            :src="iconSrc"
            :alt="description"
            :title="description"
          />
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-6">Wind: {{ windSpeed }}</div>
      <div class="col-6">Cloud coverage: {{ clouds }}</div>
    </div>
    <div class="row">
      <div class="col-6">Rain last hour: {{ rainLastHour }}</div>
      <div class="col-6">Humidity: {{ humidity }}%</div>
    </div>
    <br /><br />
    <div class="row"><div class="offset-4 col-3">Forecasts:</div></div>
    <div class="row text-center justify" style="margin: 20px">
      <div
        title="Click for this day's hourly weather"
        class=" col-sm-3 col-md-2 dailyForecast"
        style="text-align: center"
        v-for="(day, idx) in daily"
        :key="idx"
        @click="switchHourly(idx)"
      >
        <div class="row">
          <div class="col-12">
            {{ dayOfWeek(idx) }}
          </div>

          <div class="col-12">High: {{ highTemp(idx) }}</div>
          <div class="col-12">Low: {{ lowTemp(idx) }}</div>
          <div class="col-12">
            <img
              class="currentIcon"
              :src="dailyImgSrc(idx)"
              :alt="dailyDesc(idx)"
              :title="dailyDesc(idx)"
            />
          </div>
          <div class="col-12">{{ dailyDesc(idx) }}</div>

          <!--          <div class="col-12">{{ day }}</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OpenWeatherService from "../services/OpenWeatherService";
import moment from "moment";

import Geocoder from "../services/Geocoder";

export default {
  name: "DailyWeather",
  data() {
    return {
      weather: { current: { rain: "" }, weather: [], daily: [] },
      daily: [],
      place: ""
    };
  },
  methods: {
    switchHourly(idx) {
      const secs = moment(this.weather.daily[idx].dt * 1000)
        .startOf("day")
        .valueOf();
      this.$router.push({ name: "Hourly", params: { secs: secs } });
    },
    lowTemp(idx) {
      if (this.weather.daily) {
        return this.weather.daily[idx].temp.min.toFixed(0);
      } else {
        return "unknown";
      }
    },
    highTemp(idx) {
      if (this.weather.daily) {
        return this.weather.daily[idx].temp.max.toFixed(0);
      } else {
        return "unknown";
      }
    },
    dailyDesc(idx) {
      if (this.weather.daily) {
        return this.weather.daily[idx].weather[0].description;
      } else {
        return "unknown";
      }
    },
    dailyImgSrc(idx) {
      if (this.weather.daily[idx].weather) {
        return (
          "http://openweathermap.org/img/wn/" +
          this.weather.daily[idx].weather[0].icon +
          ".png"
        );
      } else {
        return "";
      }
    },
    dayOfWeek(idx) {
      if (this.weather.daily) {
        if (idx > 0) {
          return moment(this.weather.daily[idx].dt * 1000).format("ddd");
        } else {
          return "Today";
        }
      } else {
        return "unknown";
      }
    }
  },
  computed: {
    currentWeather() {
      return this.weather.current;
    },
    humidity() {
      if (this.weather.current) {
        return this.weather.current.humidity;
      } else {
        return 0;
      }
    },
    iconSrc() {
      if (this.weather.current.weather) {
        return (
          "http://openweathermap.org/img/wn/" +
          this.weather.current.weather[0].icon +
          "@2x.png"
        );
      } else {
        return "";
      }
    },
    clouds() {
      if (this.weather.current) {
        const clouds = [
          "Sunny",
          //"Clear",
          "Mostly Sunny",
          "Partly Sunny",
          "Partly Cloudy",
          "Mostly Cloudy",
          "Cloudy"
        ];
        let cloudPct = this.weather.current.clouds;
        // let cloudPct = 48;
        let idx = 0;
        while (cloudPct >= 0) {
          cloudPct -= 17;
          idx++;
        }
        return clouds[idx - 1];
      } else {
        return "Unknown Cloud Cover";
      }
    },
    windSpeed() {
      if (this.weather.current) {
        const directions = [
          "North",
          "Northeast",
          "East",
          "Southeast",
          "South",
          "Southwest",
          "West",
          "Northwest",
          "North"
        ];
        let direction = "";

        let degrees = this.weather.current.wind_deg;
        let idx = 0;
        while (degrees >= 0) {
          degrees -= 22;
          idx++;
        }
        idx = Math.ceil(idx / 2) - 1;
        direction = directions[idx];

        return this.weather.current.wind_speed + " mph to the " + direction;
      } else {
        return "Unknown wind speed";
      }
    },
    description() {
      if (this.weather.current.weather) {
        return this.weather.current.weather[0].description;
      } else {
        return "unknown";
      }
    },
    feelsLike() {
      if (this.weather.current) {
        return this.weather.current.feels_like;
      } else {
        return "Unknown";
      }
    },
    currentTemp() {
      if (this.weather.current) {
        return this.weather.current.temp;
      } else {
        return "Unknown";
      }
    },
    rainLastHour() {
      if (this.weather.current.rain) {
        return (this.weather.current.rain["1h"] / 25.4).toFixed(2) + " in.";
      } else {
        return 0;
      }
    },
    today() {
      if (this.weather.current) {
        return moment(this.weather.current.dt * 1000).format(
          "ddd, MMM Do, YYYY hh:mm A"
        );
      } else {
        return "0";
      }
    }
  },

  async created() {
    const position = await OpenWeatherService.getCoordinates();
    await Geocoder.getCityState(position)
      .then(resp => {
        let city = "";
        if (resp.data.results[0].components.city !== undefined) {
          city = resp.data.results[0].components.city;
        } else {
          city = resp.data.results[0].components.town;
        }
        this.place = city + ", " + resp.data.results[0].components.state;
        //console.log(resp.data.results[0]);
      })
      .catch(err => {
        console.log(err);
        this.place = "";
      });
    await OpenWeatherService.getWeather(position)
      .then(response => {
        this.weather = response.data;
        this.daily = this.weather.daily;
      })
      .catch(err => console.log(err));

    // console.log(this.weather);
  }
};
</script>

<style scoped>
.dailyForecast {
  border: 2px solid black;
  margin: 30px;
}
#dailyWeather {
  font-weight: bolder;
}
.currentIcon {
  border: 2px solid lightcoral;
  padding: 10px;
  border-radius: 50px 20px;
}
</style>
